<div class="container-fluid bg-white">
  <header class="row align-items-center">
    <div class="col-xl-3 col-12" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
      <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28" />
    </div>
    <div class="col-xl-9 col-12 px-xl-0">
      <app-onboarding-header></app-onboarding-header>
    </div>
  </header>
  <div class="row" id="main-container">
    <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative">
      <section class="pb-2 border-bottom">
        <div class="row mb-1">
          <div class="col-lg-6 col-md-6 col-12">
            <h1>{{ "EDUCATION_ONBOARDING" | translate }}</h1>
            <small>{{ "INSERT.EDUCATION" | translate }}</small>
          </div>
          <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
            <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL' | translate" placement="top" class="cursor-pointer text-primary">{{ "DONT_KNOW_HOW_TO_DO" | translate }}</span>
          </div>
        </div>
        <!----------------------------------------------- FORM EDUCATION --------------------------------------------->
        <div class="row align-items-center" *ngFor="let education of items_education; let i = index">
          <div class="form-group col-lg-3 col-12">
            <label [for]="'education_title_' + i">{{ "EDUCATION_TITLE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [id]="'education_title_' + i"
              [(ngModel)]="education.title_id"
              bindLabel="name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="false"
              (change)="education.subject = ''; education.name = $event.name"
              [items]="_educationTitleService.list"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
              <div class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_TITLE" | translate }}</div>
            </ng-select>
          </div>
          <div class="form-group col-lg-3 col-12">
            <label *ngIf="education.name === 'Laurea'" [for]="'education_subject_' + i">{{ "SCHOOL" | translate }} <sup class="text-danger">*</sup></label>
            <label *ngIf="education.name !== 'Laurea'" [for]="'education_subject_' + i">{{ "COURSE_STUDY" | translate }}<sup class="text-danger">*</sup></label>
            <input *ngIf="education.name !== 'Laurea'" type="text" [id]="'education_subject_' + i" class="form-control" [(ngModel)]="education.subject" />
            <ng-select
              *ngIf="education.name === 'Laurea'"
              bindValue="id"
              bindLabel="name"
              [id]="'education_title1_' + i"
              [(ngModel)]="education.subject"
              [items]="_educationSubjectService.list"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
            <div *ngIf="education.name !== 'Laurea'" class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_SCHOOL" | translate }}</div>
            <div *ngIf="education.name == 'Laurea'" class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_COURSE" | translate }}</div>
          </div>
          <div class="form-group col-lg-2 col-xl-1 col-12">
            <div>
              <label [for]="'education_vote_' + i">{{ "EDUCATION_VOTE" | translate }}</label>
              <input *ngIf="!education.current" type="text" [id]="'education_vote_' + i" class="form-control" [(ngModel)]="education.vote" />
              <input *ngIf="education.current" type="text" [id]="'education_vote2_' + i" class="form-control" [(ngModel)]="education.vote" readonly />
            </div>
          </div>
          <div class="form-group col-lg-2 col-12 d-flex align-items-center mt-2">
            <div class="custom-control custom-control-primary custom-switch mr-075">
              <input (change)="cancelVote(i)" type="checkbox" class="custom-control-input" [id]="'education_current_' + i" [(ngModel)]="education.current" />
              <label class="custom-control-label" [for]="'education_current_' + i"> </label>
            </div>
            <small>{{ "ON_STUDING" | translate }}</small>
          </div>
          <div class="form-group col-lg-2 col-12 d-flex align-items-center mt-2">
            <div class="custom-control custom-control-primary custom-switch mr-075">
              <input (change)="onSetPrimaryEducation(education, i)" type="checkbox" class="custom-control-input" [id]="'education_primary_' + i" [(ngModel)]="education.primary" />
              <label class="custom-control-label" [for]="'education_primary_' + i"> </label>
            </div>
            <small>{{ "PRIMARY_EDUCATION" | translate }}</small>
          </div>
          <div class="form-group col-xl-1 mb-0 mt-075 col-12 d-flex align-items-center" ngClass.sm="mb-1" ngClass.md="mb-1">
            <button (click)="addEducationItem()" type="button" class="btn btn-success btn-circle btn-sm mr-1" rippleEffect>
              <i class="fa fa-plus"></i>
            </button>
            <button (click)="items_education.length === 1 ? addEducationItem() : null; removeEducationItem(i)" type="button" class="btn btn-danger btn-circle btn-sm" rippleEffect>
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </section>
      <!----------------------------------------------- FORM CERTIFICATIONS --------------------------------------------->
      <section>
        <div class="row pt-2">
          <div class="col-12">
            <div class="row mb-1">
              <div class="col-12">
                <h1>{{ "TECNICAL_CERTIFICATES" | translate }}</h1>
                <small>{{ "INSERT.CERTIFICATIONS" | translate }}</small>
              </div>
            </div>
            <div class="row" *ngFor="let item of items_certifications; let i = index">
              <div class="form-group col-lg-10 pr-md-3 col-12">
                <label [for]="'cert_id_' + i">{{ "CERTIFICATE" | translate }}</label>
                <ng-select
                  [id]="'cert_id_' + i"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="item.cert_id"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_certificationService.list_enabled"
                  [(ngModel)]="item.cert_id"
                  *ngIf="!item.isNew"
                >
                </ng-select>
                <input type="text" class="form-control" [value]="item.cert_id" *ngIf="item.isNew" readonly />
              </div>
              <!---------------------------------------------------Buttons---------------------------------------->
              <div
                class="form-group col-xl-1 mb-0 mt-075 col-12 d-flex align-items-center"
                ngClass.sm="mb-1"
                ngClass.md="mb-1"
                *ngIf="items_certifications.length > 0 || (items_certifications.length === 1 && item.isNew)"
              >
                <button (click)="addItem()" type="button" class="btn btn-success btn-circle btn-sm mr-1" rippleEffect>
                  <i class="fa fa-plus"></i>
                </button>
                <button (click)="items_certifications.length === 1 ? addItem() : null; deleteItem(i)" type="button" class="btn btn-danger btn-circle btn-sm" rippleEffect>
                  <i class="fa fa-minus"></i>
                </button>
              </div>
              <div class="form-group col-12" *ngIf="item.cert_id === ''">
                <p class="sugges-new-item" [ngClass.sm]="'mb-0 mt-1'" [ngClass.md]="'mb-0 mt-1'" (click)="modalOpen(modalBasic, i)">{{ "MODAL.NOT_CERTIFICATE" | translate }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row pr-md-2">
          <div class="col-12 mb-4 d-flex justify-content-end">
            <button (click)="save()" type="submit" class="btn btn-primary">{{ "NEXT" | translate }}</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #modalBasic let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.NOT_CERTIFICATE" | translate }}</h3>
    <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
    <label [for]="'new_certificate'">{{ "CERTIFICATE" | translate }}</label>
    <input [(ngModel)]="new_certificate" type="text" [id]="new_certificate" class="form-control" />
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary w-150" (click)="addModalObject(); modal.close('Accept click')" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal -->
